import {
  MutualFundsFields,
  BondsFields,
  FDFields,
  PMSFields,
  CashFields,
  RealEstateFields,
  InternationalEquityFields,
  PreciousMetalsFields,
  DirectEquityFields,
  Filter,
  FilterType
} from './types';

export const mf_filters: Filter[] = [
  {
    title: 'Age of fund(years)',
    toggleSettingsString: 'mf-aof',
    type: FilterType.Slider,
    options_key: '',
    min_key: 'age_min',
    max_key: 'age_max',
    field: MutualFundsFields.age
  },
  {
    title: 'Fund Size (AUM in Crores)',
    toggleSettingsString: 'mf-fs',
    type: FilterType.Slider,
    options_key: 'fund_options',
    min_key: 'fund_size_min',
    max_key: 'fund_size_max',
    field: MutualFundsFields.size
  },
  {
    title: 'Asset Class',
    toggleSettingsString: 'mf-ac',
    type: FilterType.Options,
    items_key: 'asset_class_items',
    selected_items_key: 'selected_asset_class_items',
    field: MutualFundsFields.class
  },
  {
    title: 'Scheme Category',
    toggleSettingsString: 'mf-sc',
    type: FilterType.Options,
    items_key: 'scheme_category_items',
    selected_items_key: 'selected_scheme_category_items',
    field: MutualFundsFields.scheme
  },
  {
    title: 'AMC',
    toggleSettingsString: 'mf-amc',
    type: FilterType.Options,
    items_key: 'amc_items',
    selected_items_key: 'selected_amc_items',
    field: MutualFundsFields.amc
  },
  {
    title: 'Suggested Opt',
    toggleSettingsString: 'mf-sopt',
    type: FilterType.Options,
    items_key: 'suggested_opt_items',
    selected_items_key: 'selected_suggested_opt_items',
    field: MutualFundsFields.options
  },
  {
    title: 'Strategy',
    toggleSettingsString: 'mf-strat',
    type: FilterType.Options,
    items_key: 'strategy_items',
    selected_items_key: 'selected_strategy_items',
    field: MutualFundsFields.strategy
  },
  {
    title: 'Benchmark',
    toggleSettingsString: 'mf-bench',
    type: FilterType.Options,
    items_key: 'benchmark_items',
    selected_items_key: 'selected_benchmark_items',
    field: MutualFundsFields.benchmark
  },
  {
    title: 'Risk',
    toggleSettingsString: 'mf-risk',
    type: FilterType.Options,
    items_key: 'risk_items',
    selected_items_key: 'selected_risk_items',
    field: MutualFundsFields.risk
  },
  {
    title: 'Timeframe',
    toggleSettingsString: 'mf-tf',
    type: FilterType.Options,
    items_key: 'timeframe_items',
    selected_items_key: 'selected_timeframe_items',
    field: MutualFundsFields.timeframe
  },
  {
    title: 'Tax',
    toggleSettingsString: 'mf-tax',
    type: FilterType.Options,
    items_key: 'tax_items',
    selected_items_key: 'selected_tax_items',
    field: MutualFundsFields.tax
  }
];

export const bonds_filters: Filter[] = [
  {
    title: 'Bonds type',
    toggleSettingsString: 'bonds-type',
    type: FilterType.Options,
    items_key: 'types_items',
    selected_items_key: 'selected_types_items',
    field: BondsFields.type
  },
  {
    title: 'Registrar',
    toggleSettingsString: 'bonds-reg',
    type: FilterType.Options,
    items_key: 'registrar_items',
    selected_items_key: 'selected_registrar_items',
    field: BondsFields.registrar
  }
];

export const fd_filters: Filter[] = [
  {
    title: 'Tax type',
    toggleSettingsString: 'fd-tax',
    type: FilterType.Options,
    items_key: 'tax_items',
    selected_items_key: 'selected_tax_items',
    field: FDFields.tax
  },
  {
    title: 'Category',
    toggleSettingsString: 'fd-cat',
    type: FilterType.Options,
    items_key: 'category_items',
    selected_items_key: 'selected_category_items',
    field: FDFields.category
  },
  {
    title: 'Bank',
    toggleSettingsString: 'fd-bank',
    type: FilterType.Options,
    items_key: 'bank_items',
    selected_items_key: 'selected_bank_items',
    field: FDFields.bank
  },
  {
    title: 'NBFC',
    toggleSettingsString: 'fd-nbfc',
    type: FilterType.Options,
    items_key: 'nbfc_items',
    selected_items_key: 'selected_nbfc_items',
    field: FDFields.nbfc
  }
];

export const pms_filters: Filter[] = [
  {
    title: 'Name',
    toggleSettingsString: 'pms-citem',
    type: FilterType.Options,
    items_key: 'company_item',
    selected_items_key: 'selected_company_items',
    field: PMSFields.name
  }
];

export const cash_filters: Filter[] = [
  {
    title: 'Type',
    toggleSettingsString: 'cash-type',
    type: FilterType.Options,
    items_key: 'account_type',
    selected_items_key: 'selected_account_type',
    field: CashFields.type
  }
];

export const re_filters: Filter[] = [
  {
    title: 'Type',
    toggleSettingsString: 're-type',
    type: FilterType.Options,
    items_key: 'type',
    selected_items_key: 'selected_types',
    field: RealEstateFields.type
  }
];

export const iequity_filters: Filter[] = [
  {
    title: 'Type',
    toggleSettingsString: 'iequity-type',
    type: FilterType.Options,
    items_key: 'type',
    selected_items_key: 'selected_types',
    field: InternationalEquityFields.type
  }
];

export const pm_filters: Filter[] = [
  {
    title: 'Type',
    toggleSettingsString: 'pm-type',
    type: FilterType.Options,
    items_key: 'type',
    selected_items_key: 'selected_types',
    field: PreciousMetalsFields.type
  }
];

export const de_filters: Filter[] = [
  {
    title: 'Type',
    toggleSettingsString: 'de-type',
    type: FilterType.Options,
    items_key: 'type',
    selected_items_key: 'selected_types',
    field: DirectEquityFields.type
  }
];



// WEBPACK FOOTER //
// ./src/app/modules/asset-selection/asset-catalog/filters.ts